<template>
  <div class="hr-review-document-info" :class="{ '__no-border': !label }">
    <span class="__label">{{ label }}</span>
    <span class="__value fs-mask">
      {{ value }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'hr-review-document-info',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped>
@import '~@/core/style-vars.scss';
// This is the US form related view stylings
.hr-review-document-info {
  text-align: left;
  margin: 0 6px;
  padding: 12px 0;
  display: grid;
  align-items: center;
  grid-template-columns: 300px auto auto;
  grid-gap: 16px;
  border-bottom: 1px solid var(--dpt-border-color);

  @media only screen and (max-device-width: 768px) {
    grid-template-columns: 50% auto auto;
  }
}

.hr-review-document-info.__no-border {
  border-bottom: none;
}

.__label {
  color: var(--dpt-text-color);
  font-weight: 600;
  margin-right: 8px;
}

.__value {
  white-space: break-spaces;
  color: var(--dpt-text-color);
  word-break: break-all;
}
</style>
